import { ActivatedRoute } from '@angular/router';

export function getReturnUrlFromRoute(activatedRoute: ActivatedRoute): string {
  return activatedRoute.snapshot.pathFromRoot.map(route => route.url[0]).join('/');
}
